(() => {
  'use strict';
  const selector = '#main-product-compare,s,del,[id*="price"],[class*="price"],[data-ht-per-night],[data-ht-mouth-unit],[class*="included"][class*="value"],.ht-offer-value';
  const trim = (text) => text.replace(/(\d)\.00(?=\s*(?:[A-Z]{3}\b|\/|$|<)|\s|[^\d.,])/g, '$1').replace(/\s*\bUSD\b/g, '');
  const clean = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      if (!node.parentElement?.closest(selector) || node.parentElement.closest('script,style,textarea')) return;
      const next = trim(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
    let text;
    while ((text = walker.nextNode())) clean(text);
  };
  const start = () => {
    const root = document.body.classList.contains('template-index')
      ? document.querySelector('#main-product-price')?.closest('.shopify-section')
      : document.querySelector('main');
    if (!root) return;
    clean(root);
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') clean(record.target);
        else record.addedNodes.forEach(clean);
      }
    }).observe(root, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();